import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Accordion } from '~/eds/src/components/Accordion/Accordion';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { ListItems } from '~/eds/src/components/ListItems/ListItems';
import { Text } from '~/eds/src/components/Text/Text';
import { QueryFilters } from '~/features/advanced-search/query-filters/QueryFilters';
import { slices } from '~/redux/slices';
import { sortByStringValue } from '~/utils/array';

import { INITIAL_FILTERS } from '../../constants';
import { getModelTitle } from './utils';

export const CategoryScope = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const query = useSelector(slices.xRayLibrary.selectors.selectQuery);

  const categoryModels = useSelector(
    slices.xRayLibrary.selectors.selectCategoryModels,
  );

  const categoryModelsArray = Array.from(categoryModels.entries()).map(
    ([label, value]) => ({ label, value }),
  );

  return (
    <>
      <Text variant="section">
        {intl.formatMessage({
          id: 'CategoryScope.customScope',
          defaultMessage: 'Custom Scope',
          description: 'Section title for custom scope configuration',
        })}
      </Text>
      <Accordion
        isIndented
        chipPosition="left"
        border="none"
        itemGap="m"
        items={categoryModelsArray.map((categoryModel) => {
          const { label, value: models } = categoryModel;

          return {
            key: label,
            isExpanded: true,
            title: getModelTitle(label, models),
            content: (
              <Layout preset="subsections">
                <QueryFilters
                  defaultFilters={INITIAL_FILTERS}
                  query={query.categoryQuery[label] ?? []}
                  mode="preview"
                  onQueryChange={(updatedQuery) => {
                    dispatch(
                      slices.xRayLibrary.actions.setQuery({
                        ...query,
                        categoryQuery: {
                          ...query.categoryQuery,
                          [label]: updatedQuery,
                        },
                      }),
                    );
                  }}
                />
                <Accordion
                  border="none"
                  items={[
                    {
                      title: intl.formatMessage({
                        id: 'CategoryScope.includedModels',
                        defaultMessage: 'Included models',
                        description: 'Title for included models section',
                      }),
                      content: (
                        <ListItems
                          as="ul"
                          items={models
                            .sort(sortByStringValue('label'))
                            .map((model) => ({
                              title: model.label,
                              icon: 'view' as const,
                              iconColor: 'inherit' as const,
                              onClick: () => {
                                dispatch(
                                  slices.xRayLibrary.actions.setModelPreview(
                                    model,
                                  ),
                                );
                              },
                            }))}
                        />
                      ),
                    },
                  ]}
                />
              </Layout>
            ),
          };
        })}
      />
    </>
  );
};
